import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllConfigs, switchSmaConfig, deleteSmaConfig } from '../../store/slices/sma.slice';
import { Table, Popconfirm, Typography } from 'antd';

import Button from '@mui/material/Button';
import EventCard from "../../components/EventCard/EventCard";
import Avatars from "../../components/Graphics/Avatars";
import {useEnsureTickersLoaded} from "../../hooks/useEnsureTickersLoaded";
const { Title } = Typography;



const SmaCard = ({ key, config, handleOpenConfig, handleDeleteConfig }) => {
    const { id, name, etfs } = config;
    const { tickers } = useEnsureTickersLoaded(etfs.map(etf => etf.symbol));

    // Extract ETF information for display
    const etfNames = etfs.map(etf => etf.symbol);
    const etfWeights = etfs.map(etf => `${etf.weight}%`);

    // Calculate total portfolio allocation
    const totalAllocation = etfs.reduce((sum, etf) => sum + etf.weight, 0);

    return (
        <EventCard
            title={name || `Untitled (${key})`}
            text="Open SMA Draft"
            content={
                    <Avatars
                        urls={tickers.map(x=>x.logo)} // Placeholder for ETF logos
                        alt={etfNames}
                        size={48}
                    />
            }
            bottomLeft={<div>{etfs.length} ETFs - {totalAllocation.toFixed(1)}% Allocated</div>}
            bottomRight={
                <Button
                    variant={'outlined'}
                    onClick={() => handleOpenConfig(id)}
                >
                    Open
                </Button>
            }
            color="green"
        />
    );
};


const SmaDrafts = ({ onSubmit }) => {
  const dispatch = useDispatch();
  const configs = useSelector(selectAllConfigs);
  console.log(configs)
  // Function to switch between SMA configs
  const handleConfigClick = (configId) => {
    dispatch(switchSmaConfig({ smaConfigId: configId }));
    onSubmit?.();  // Callback after switching the config
  };

  // Function to delete a config
  const handleDeleteConfig = (configId) => {
    dispatch(deleteSmaConfig({ smaConfigId: configId }));
  };


  return (
    <div style={{margin: 'auto', maxWidth: 1000}}>
      <Title level={2} style={{ marginBottom: '20px' }}>SMA Portfolios In-Progress</Title>
        {configs.map((config, index) => (
            <SmaCard
                key={index}
                config={config}
                handleOpenConfig={handleConfigClick}
                handleDeleteConfig={handleDeleteConfig}
            />
        ))}
    </div>
  );
};

export default SmaDrafts;
